export { default } from './gap-genius-info.js';
